import React from "react";
import Mission from "./benifits";
import ServiceCommitment from "./keyServices";
import AboutMotoDoctor from "./aboutMotoDoctor";
import { Helmet } from "react-helmet-async";

function About() {
  return (
    <>
      <Helmet>
        {/* TITLE */}
        <title>About MotoDoctor - Chennai's Trusted Bike Rescue & Repair Partner</title>

        {/* META DESCRIPTION */}
        <meta
          name="description"
          content="Learn how MotoDoctor brings fast, reliable support for Chennai riders through skilled technicians, smart technology, and an easy-to-use mobile app designed to keep every journey smooth and worry-free."
        />

        {/* CANONICAL */}
        <link rel="canonical" href="https://www.motodoctor.in/about" />

        {/* H1 AS META */}
        <meta name="heading" content="About MotoDoctor – Your Motorcycle Rescue Partner" />

        {/* H2 NOT PROVIDED → NO META SUBHEADING */}
      </Helmet>

      <div>
        <Mission />
        <ServiceCommitment />
        <AboutMotoDoctor />
      </div>
    </>
  );
}

export default About;
